export default "__VITE_ASSET__OMx59aXw__"